import { CalendarCheck } from "lucide-react";
import { WHATSAPP_SJDS, WHATSAPP_MANAGUA, waLink } from "@/lib/api";
import { useLang } from "@/i18n/LangContext";

const OFFICES = {
  sjds: { number: WHATSAPP_SJDS, city: "San Juan del Sur" },
  managua: { number: WHATSAPP_MANAGUA, city: "Managua" },
};

export const NextDayButton = ({ office = "sjds", showCity = false, testId = "next-day-availability-btn", className = "" }) => {
  const { tr } = useLang();
  const { number, city } = OFFICES[office];
  const msg = tr(
    `Hello Dr. Cora! I'm in ${city} and would like to check next-day dental care availability. Is there an opening tomorrow?`,
    `¡Hola Dra. Cora! Estoy en ${city} y quisiera consultar disponibilidad de atención dental para mañana. ¿Hay algún espacio disponible?`
  );
  return (
    <a href={waLink(msg, number)} target="_blank" rel="noreferrer" className={`inline-flex items-center justify-center gap-2 rounded-full border border-[#00C9B7] text-[#00C9B7] px-6 py-3.5 text-xs font-bold uppercase tracking-widest hover:bg-[#00C9B7] hover:text-[#0B0F12] transition-colors ${className}`} data-testid={testId}>
      <CalendarCheck size={16} /> {tr("Check next-day availability", "Consultar disponibilidad para mañana")}{showCity && ` · ${city}`}
    </a>
  );
};
